import React from "react";
import { Link } from "react-router-dom";
import { Music2, Users } from "lucide-react";

// Vimeo id enviado por el cliente: https://vimeo.com/1218430099
const VIMEO_ID = "1218430099";
const VIMEO_SRC = `https://player.vimeo.com/video/${VIMEO_ID}?background=1&autoplay=1&loop=1&muted=1&controls=0&title=0&byline=0&portrait=0&transparent=0`;

export default function HomeHeroVideo() {
  return (
    <section className="relative w-full min-h-[100svh] flex items-center overflow-hidden bg-black">
      {/* Background video (Vimeo) + fallback poster */}
      <div className="absolute inset-0 -z-0 pointer-events-none">
        {/* Fallback poster (visible detrás si el iframe no carga o queda bloqueado) */}
        <img
          src="https://images.unsplash.com/photo-1516280440614-37939bbacd81?w=1800&q=85"
          alt=""
          className="absolute inset-0 w-full h-full object-cover opacity-70"
        />
        <div className="absolute inset-0 w-full h-full">
          <iframe
            src={VIMEO_SRC}
            title="Kilombo — Hero"
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            referrerPolicy="no-referrer"
            className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[177.77vh] h-[100vh] min-w-full min-h-full pointer-events-none"
            aria-hidden="true"
          />
        </div>
        {/* Overlays SUAVES para que el video se vea con vida sin perder legibilidad */}
        <div className="absolute inset-0 bg-black/30" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-transparent to-black/90" />
        <div className="absolute inset-0 bg-[radial-gradient(80%_60%_at_50%_45%,rgba(0,0,0,0.25)_0%,transparent_75%)]" />
        <div className="absolute inset-0 noise-overlay pointer-events-none" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-6xl mx-auto px-6 md:px-10 pt-32 pb-20 md:pt-40 md:pb-28 text-center">
        <div className="inline-flex items-center gap-3 mb-8 md:mb-10">
          <span className="h-px w-8 bg-white/40" />
          <p className="font-mono-caps text-[11px] md:text-xs tracking-[0.35em] uppercase text-white/70">Sobre Kilombo</p>
          <span className="h-px w-8 bg-white/40" />
        </div>

        <h1
          data-testid="home-hero-title"
          className="font-display font-black leading-[1.05] text-[32px] sm:text-5xl md:text-6xl lg:text-[76px] xl:text-[88px] tracking-tight"
          style={{ wordBreak: "keep-all", overflowWrap: "normal" }}
        >
          <span className="block text-white">Activamos</span>
          <span className="block bg-gradient-to-r from-[#ff6a2b] via-[#ff8a3c] to-[#ffb46b] bg-clip-text text-transparent pt-1">emociones en dos</span>
          <span className="block bg-gradient-to-r from-[#5be0c3] via-[#2ec9a8] to-[#1fb391] bg-clip-text text-transparent pt-1">universos</span>
        </h1>

        <p
          className="mt-14 md:mt-20 max-w-3xl mx-auto text-white/90 text-lg md:text-2xl lg:text-3xl leading-snug font-light"
          style={{ wordBreak: "keep-all", overflowWrap: "normal" }}
        >
          Somos un estudio de contenidos que transforma marcas, artistas y equipos a través del <span className="text-white font-semibold">poder de la música, el arte y la creatividad</span>.
        </p>

        <div className="mt-10 md:mt-12 flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-4">
          <Link
            to="/music"
            data-testid="hero-cta-music"
            className="btn-shine group inline-flex items-center justify-center gap-3 rounded-full pl-6 pr-5 py-4 min-w-[220px] font-mono-caps text-xs md:text-sm tracking-[0.22em] uppercase text-black shadow-lg shadow-[#ff6a2b]/25 hover:shadow-[#ff6a2b]/50 transition-all"
            style={{ background: "linear-gradient(135deg, #ffb46b 0%, #ff6a2b 60%, #ff4d1a 100%)" }}
          >
            <Music2 className="w-4 h-4" />
            Kilombo Music
            <span className="w-7 h-7 rounded-full bg-black text-white flex items-center justify-center transition-transform group-hover:translate-x-0.5">→</span>
          </Link>
          <Link
            to="/teams"
            data-testid="hero-cta-teams"
            className="btn-shine group inline-flex items-center justify-center gap-3 rounded-full pl-6 pr-5 py-4 min-w-[220px] font-mono-caps text-xs md:text-sm tracking-[0.22em] uppercase text-black shadow-lg shadow-[#2ec9a8]/25 hover:shadow-[#2ec9a8]/50 transition-all"
            style={{ background: "linear-gradient(135deg, #5be0c3 0%, #2ec9a8 55%, #1f9bd6 100%)" }}
          >
            <Users className="w-4 h-4" />
            Kilombo Teams
            <span className="w-7 h-7 rounded-full bg-black text-white flex items-center justify-center transition-transform group-hover:translate-x-0.5">→</span>
          </Link>
        </div>

        {/* Scroll cue removed */}
      </div>
    </section>
  );
}
